import React from 'react'

export const ArrowDown = () => {
  return (
    <svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.24609 7.19664L10.0004 12.9512L15.7549 7.19664"
        stroke="white"
        strokeWidth="2"
      />
    </svg>
  )
}
